import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthTokenDto } from 'src/app/models/AuthTokenDto';
import { AccountService } from '../account/account.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private accountService: AccountService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let navigate: boolean = true;
    let authToken: AuthTokenDto = JSON.parse(localStorage.getItem('AuthToken'));

    if (authToken == null) {
      navigate = false;
    } else {
      let expiryDate = Date.parse(authToken.expires);
      let now = Date.now();

      if (expiryDate < now) {
        navigate = false;
      }
    }

    navigate = true;

    if (navigate) {
      return true;
    } else {
      this.accountService.showLoginAlert();
    }

  }
}
